// owner 2026-10-15 (TAMBAHAN-OWNER-OKT A3): "Bantuan kendala" — the guide of the user's
// role and a problem report for Tim iartech. Pure data + helpers (no imports, Jest-tested).
// The report never carries usernames, customer data or passwords: it is built on the
// user's screen and sent by the user (WhatsApp / copy); the server does not store it.

const UMUM = {
  judul: "Aturan umum (semua karyawan)",
  butir: [
    "Pakai akun sendiri. Jangan meminjam atau meminjamkan akun.",
    "Jangan memberi tahu password ke siapa pun, juga ke Tim iartech.",
    "Tekan \"Mulai\" hanya saat mulai bekerja, \"Selesai\" hanya saat benar-benar selesai.",
    "Menu SPK: semua pos boleh melihat semua SPK. Yang dikerjakan tetap hanya pekerjaan pos sendiri di menu Antrean.",
    "Data customer hanya untuk pekerjaan. Jangan difoto, disalin, atau disebarkan.",
    "Selesai memakai HP atau komputer bersama, tekan Logout.",
  ],
};

const PRODUKSI_MASALAH = [
  "Tidak bisa menyelesaikan pekerjaan: lapor Owner/Manager supaya pekerjaan dialihkan.",
  "Ada tulisan merah \"REWORK\": baca alasannya dulu sebelum \"Mulai\".",
];

const P = {
  kasir: {
    judul: "Kasir/CS",
    langkah: [
      "Harga: menu Price List (Enduser, Reseller, Member).",
      "Customer baru: menu Customer, tombol Tambah. Kasir/CS boleh membuat tipe Enduser, Reseller, atau Member.",
      "Order baru: menu Transaksi DP, DTF, Custom, atau Jersey.",
      "Pembayaran: menu Pembayaran, cari faktur, catat DP atau pelunasan.",
      "Pengingat tagihan: menu Pembayaran, bagian \"Jadwal pengingat hari ini\", tekan Kirim WA.",
      "ACC customer (DTF dan Jersey): menu ACC & Mockup. Jersey: mockup bisa 6 bagian (tampak penuh, logo, dada depan, dada belakang, kerah, lengan).",
      "Pertanyaan \"pesanan saya sampai mana?\": menu Status Order.",
      "Lembar kerja Jersey: menu SPK, ikon mata (lihat di layar).",
    ],
    tidakBoleh: ["Menyerahkan pesanan sebelum lunas.", "Membatalkan nota atau mengoreksi pembayaran (hanya Owner).",
      "Mengubah tipe customer yang sudah ada (hanya Owner).", "Diskon tanpa alasan."],
    masalah: ["Salah input order atau pembayaran: lapor Owner.", "Order belum masuk produksi: cek menu SPK, alasannya tertulis di sana."],
  },
  desain: {
    judul: "Desain",
    langkah: ["Pekerjaan: menu Antrean, tekan Mulai, lalu Selesai.", "Upload mockup: menu ACC & Mockup. Jersey: pilih bagian mockup (tampak penuh, logo, dada depan, dada belakang, kerah, lengan).",
      "Data Jersey: menu Jersey Siap Desain.", "Melihat SPK lain: menu SPK."],
    tidakBoleh: ["Meng-upload file desain produksi. Yang di-upload hanya mockup."],
    masalah: ["Pekerjaan DTF/Jersey belum muncul: order masih menunggu ACC, DP, atau stok.", ...PRODUKSI_MASALAH],
  },
  jersey: {
    judul: "Pattern & Layout, Sublim, Press",
    langkah: ["Pekerjaan: menu Antrean, tekan Mulai.", "Detail: tekan nomor SPK untuk melihat mockup dan lembar kerja.",
      "Selesai: isi form pos (checklist, jumlah hasil, jumlah reject), lalu Selesai.", "Press: bagi pcs ke penjahit saat Selesai."],
    tidakBoleh: ["Menekan \"Selesai\" sebelum benar-benar selesai.", "Mengisi jumlah hasil asal-asalan."],
    masalah: ["Bahan rusak di pos ini: isi jumlah reject di form.", ...PRODUKSI_MASALAH],
  },
  jahit: {
    judul: "Cutting & Jahit (Penjahit)",
    langkah: ["Pekerjaan: menu Antrean, ambil bagian Anda, tekan Mulai.", "Detail: nama dan nomor pemain terlihat di lembar kerja.",
      "Selesai: isi form, lalu Selesai.", "Gaji: menu Borongan Saya."],
    tidakBoleh: ["Memindahkan bagian ke penjahit lain sendiri (hanya Owner/Manager)."],
    masalah: ["Muncul \"Tarif jahit belum ada\": beri tahu Owner.", ...PRODUKSI_MASALAH],
  },
  qc: {
    judul: "Quality Control",
    langkah: ["Pekerjaan: menu Antrean, tekan Mulai.", "Periksa setiap pemain, lalu Lulus atau Reject.", "Reject: pilih pos yang mengerjakan ulang dan penyebabnya."],
    tidakBoleh: ["Menekan \"Lulus\" tanpa memeriksa setiap pemain."],
    masalah: ["Tidak yakin pos mana yang salah: pilih penyebab \"Tidak diketahui\", lalu lapor Owner/Manager."],
  },
  operator: {
    judul: "Operator (Digital Print, DTF, Press DTF, Outdoor & Finishing)",
    langkah: ["Pekerjaan: menu Antrean, tekan Mulai, lalu Selesai.", "Melihat SPK lain: menu SPK."],
    tidakBoleh: ["Menekan \"Mulai\" pada pekerjaan pos lain."],
    masalah: ["Mesin rusak: lapor Owner/Manager supaya pekerjaan dialihkan."],
  },
  finance: {
    judul: "Finance",
    langkah: ["Pembelian bahan: menu Pembelian.", "Stok dan hitung fisik: menu Stok.", "Buku Kas: menu Buku Kas.",
      "Riwayat pembayaran customer: menu Riwayat Pembayaran (hanya melihat).", "Lembar kerja Jersey: menu SPK, tombol Unduh Excel (A4)."],
    tidakBoleh: ["Mengubah atau membatalkan pembayaran customer (koreksi hanya Owner).", "Mengubah stok tanpa pencatatan."],
    masalah: ["Salah catat pembelian atau kas: lapor Owner untuk dikoreksi."],
  },
  manager: {
    judul: "Manager",
    langkah: ["Pantau produksi: menu Monitoring.", "Alihkan pekerjaan: menu Antrean, buka SPK, Alihkan.", "Ajukan batal SPK: menu SPK, ikon mata, Ajukan batal.",
      "Lembar kerja Jersey: menu SPK, tombol Unduh Excel (A4).", "Akun karyawan: menu Users."],
    tidakBoleh: ["Mengerjakan langkah operator.", "Mengubah harga jual atau HPP.", "\"Lepas paksa\" dan \"Set READY\" (hanya Owner)."],
    masalah: ["Pengajuan batal belum diputuskan: hubungi Owner."],
  },
  admin: {
    judul: "Owner",
    langkah: ["Ringkasan: Dashboard.", "Pembayaran dan koreksi: menu Pembayaran.", "Riwayat pembayaran semua faktur: menu Riwayat Pembayaran.",
      "Customer baru per tipe: menu Customer, bagian \"Customer baru\".", "Pengingat tagihan dan teks WhatsApp: menu WhatsApp.",
      "Nomor WhatsApp Tim iartech untuk laporan kendala: menu Pengaturan."],
    tidakBoleh: [],
    masalah: ["Hanya Owner: batal nota, koreksi pembayaran, lepas paksa stok, buka kunci Jersey, harga, akun, pengaturan."],
  },
};

const PETA = {
  admin: "admin", manager: "manager", kasir: "kasir", finance: "finance", desain: "desain",
  pattern_layout: "jersey", op_sublim: "jersey", op_press: "jersey", jahit: "jahit", qc: "qc",
};

export function panduanPeran(role) {
  return P[PETA[role] || "operator"];
}
export const panduanUmum = () => UMUM;

// document numbers (JRS20261013001, SPK-2026-000417, CUST-000012) are allowed
const NOMOR_DOKUMEN = /\b[A-Za-z]{2,6}[-/]?\d[\d-]*/g;
const TELEPON_ATAU_REKENING = /\d(?:[\s.-]?\d){9,}/;  // 10+ digits: phone, bank account, NIK
const EMAIL = /[^\s@]+@[^\s@]+\.[^\s@]+/;
const RAHASIA = /\b(password|passwd|kata\s*sandi|sandi|pin|otp)\s*[:=]\s*\S+/i;

// What must be removed before the report may leave the screen ([] = fine).
export function cekSensitif(teks) {
  const t = String(teks || "");
  const tanpaDokumen = t.replace(NOMOR_DOKUMEN, " ");
  const out = [];
  if (TELEPON_ATAU_REKENING.test(tanpaDokumen)) out.push("nomor HP / rekening / NIK");
  if (EMAIL.test(t)) out.push("alamat email");
  if (RAHASIA.test(t)) out.push("password / PIN / kode OTP");
  return out;
}

// The text sent to Tim iartech: only what helps to find the problem.
export function susunLaporan({ apa, menu, sudahDicoba, waktu, peran, versi, perangkat }) {
  const baris = [
    "*Laporan kendala SOQPRINT*",
    `Waktu: ${waktu || "-"}`,
    `Peran: ${peran || "-"}`,
    `Menu/halaman: ${menu || "-"}`,
    `Versi aplikasi: ${versi || "-"}`,
    `Perangkat: ${perangkat || "-"}`,
    "",
    "Apa yang terjadi:",
    String(apa || "").trim() || "-",
  ];
  if (String(sudahDicoba || "").trim()) baris.push("", "Yang sudah dicoba:", String(sudahDicoba).trim());
  return baris.join("\n");
}

export const waLaporan = (nomor, teks) => (nomor ? `https://wa.me/${nomor}?text=${encodeURIComponent(teks)}` : null);

// "HP Android" / "iPhone" / "Komputer Windows" ... (no full user agent: less fingerprinting)
export function jenisPerangkat(ua) {
  const u = String(ua || "");
  if (/Android/i.test(u)) return "HP Android";
  if (/iPhone|iPad/i.test(u)) return "iPhone/iPad";
  if (/Windows/i.test(u)) return "Komputer Windows";
  if (/Mac OS/i.test(u)) return "Komputer Mac";
  if (/Linux/i.test(u)) return "Komputer Linux";
  return "Lainnya";
}
